import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useModal } from "../../context/ModalProvider";
import { PreferencesModal } from "./PreferencesModal";

/**
 * Global `?prefs=1` deep link — opens the Preferences menu modal on whatever SPA
 * route the user landed on, then strips the param. Mounted once at the app gate
 * (post-auth) so `/my-training?prefs=1`, `/plan/abc?prefs=1`, etc. all work.
 */
export function PreferencesDeepLink() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { open, close } = useModal();
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    if (searchParams.get("prefs") !== "1") return;
    handledRef.current = true;
    const id = open(<PreferencesModal onClose={() => close(id)} />);
    const next = new URLSearchParams(searchParams);
    next.delete("prefs");
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams, open, close]);

  return null;
}
